<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <div class="page-head q-mb-lg">
      <section class="widget-section widget-section--filter full-width flex no-wrap items-center q-mb-lg">
        <q-form ref="form" class="full-width">
          <div class="row no-wrap full-width q-col-gutter-sm q-mb-md">
            <div class="col">
              <q-input
                v-model="filters.id"
                label="ID"
                outlined
                dense
                clearable
                bg-color="white"
                @update:model-value="filterTable"
                @clear="reloadTable()"
              />
            </div>
            <div class="col">
              <q-input
                v-model="filters.uuid"
                label="UUID"
                outlined
                dense
                clearable
                bg-color="white"
                @update:model-value="filterTable"
                @clear="reloadTable()"
              />
            </div>
            <div class="col">
              <q-input
                v-model="filters.schema"
                label="Schema"
                outlined
                dense
                clearable
                bg-color="white"
                @update:model-value="filterTable"
                @clear="reloadTable()"
              />
            </div>
          </div>
          <div class="row no-wrap full-width q-col-gutter-sm">
            <div class="col flex no-wrap q-col-gutter-sm">
              <DatePicker
                v-model="filters.dateFrom"
                @update:model-value="filterTable"
                label="Created after"
                class="full-width"
                @clear="
                  () => {
                    filters.dateFrom = undefined;
                  }
                "
              />
            </div>
            <div class="col flex no-wrap q-col-gutter-sm">
              <DatePicker
                v-model="filters.dateTo"
                @update:model-value="filterTable"
                label="Created before"
                class="full-width"
                @clear="
                  () => {
                    filters.dateTo = undefined;
                  }
                "
              />
            </div>
            <div class="col-2 flex no-wrap q-col-gutter-sm">
              <q-checkbox
                v-model="filters.deleted"
                @update:model-value="filterTable"
                label="Show deleted"
                class="full-width"
              />
            </div>
          </div>
        </q-form>
        <q-icon @click="resetFilters" name="engp:engp-ico-restart" class="q-ml-md cursor-pointer" size="20px">
          <q-tooltip>Reset</q-tooltip>
        </q-icon>
      </section>
      <section class="widget-section widget-section--btn q-ml-md">
        <q-btn color="primary" @click="$router.push('/service-schemas/new')" no-caps class="btn--no-hover"
          >New schema</q-btn
        >
      </section>
    </div>

    <section class="widget-section widget-section--table">
      <ServiceSchemasTable
        ref="schemasTable"
        :rowsPerPageOptions="[20, 50, 100]"
        class="fixed-table"
        :filters="filters"
        @confirmDeleteSchema="showConfirm($event)"
      />
    </section>
  </q-page>

  <q-dialog v-model="showConfirmDialog" class="single-service-page" persistent>
    <q-card style="min-width: 480px; border-radius: 0px">
      <q-toolbar class="shadow-2 q-py-sm q-px-md">
        <q-toolbar-title class="text-weight-bold">
          <strong>Delete schema</strong>
        </q-toolbar-title>
        <q-btn
          icon="close"
          style="min-width: 20px"
          round
          flat
          class="btn--no-hover"
          @click="showConfirmDialog = false"
        ></q-btn>
      </q-toolbar>
      <q-card-section class="q-mx-md q-px-none q-pb-none" style="border-top: 2px solid var(--q-primary)">
        <p>Are you sure you want to delete this schema?</p>
      </q-card-section>
      <q-card-actions class="q-px-md q-pt-none q-pb-lg">
        <q-btn
          style="border-radius: 10px; text-transform: capitalize"
          color="primary"
          text-color="text-color"
          :loading="deleteLoading"
          :disabled="deleteLoading"
          @click="deleteSchema"
          >Yes</q-btn
        >
        <q-btn
          style="border-radius: 10px; text-transform: capitalize"
          class="btn--no-hover"
          flat
          @click="showConfirmDialog = false"
          >No</q-btn
        >
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import DatePicker from '../allItems/components/DatePicker.vue';
import ServiceSchemasTable from './components/ServiceSchemasTable.vue';
import { createWorkFlow } from '../registrations/api/api';

export default {
  name: 'ServiceSchemasPage',
  components: {
    DatePicker,
    ServiceSchemasTable,
  },
  data() {
    return {
      filters: {
        id: undefined,
        uuid: undefined,
        schema: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        deleted: false,
      },
      loading: false,
      timeout: undefined,
      showConfirmDialog: false,
      currentSchema: undefined,
      deleteLoading: false,
    };
  },
  methods: {
    async deleteSchema() {
      this.deleteLoading = true;
      const deleteSchemaWorkflow = {
        workflowId: 'engprt.delete-service-schema',
        inputVariables: {
          id: this.currentSchema.id,
          uuid: this.currentSchema.uuid,
        },
      };
      try {
        await createWorkFlow(deleteSchemaWorkflow);
        this.$notify('positive', 'Success', 'Schema will be deleted.');
        this.reloadTable();
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.deleteLoading = false;
        this.currentSchema = undefined;
        this.showConfirmDialog = false;
      }
    },
    showConfirm(config) {
      this.currentSchema = config;
      this.showConfirmDialog = true;
    },
    resetFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined;
      });
      this.filters.deleted = false;
      this.reloadTable();
    },
    filterTable() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            this.reloadTable();
          }, 1500);
        }
      });
    },
    reloadTable() {
      this.$refs.schemasTable?.reload();
    },
  },
  mounted() {
    const query = this.$route.query;

    Object.keys(this.filters).forEach((key) => {
      this.filters[key] = query[key] || undefined;
      if (key === 'deleted') {
        this.filters[key] = query[key] === 'true';
      }
    });

    this.reloadTable();
  },
};
</script>

<style lang="scss" scoped>
.widget-section {
  padding: 16px 16px 16px 5px;
  margin-bottom: 0;
}
.widget-section--btn {
  padding: 16px;
  min-width: 150px;
}
.long-desc {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.showBanner {
  .fixed-table {
    height: calc(100vh - 300px);
  }
}
.fixed-table {
  height: calc(100vh - 240px);
}
.page-head {
  display: flex;
}
</style>
